var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38594",
    "data-name": "Group 38594",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14623",
    "data-name": "Rectangle 14623",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37967",
    "data-name": "Group 37967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37966",
    "data-name": "Group 37966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33365",
    "data-name": "Path 33365",
    d: "M279,279.379a1.1,1.1,0,0,0,1.094,1.094h1.285a1.1,1.1,0,0,0,1.094-1.094v-1.285A1.1,1.1,0,0,0,281.379,277h-1.285A1.1,1.1,0,0,0,279,278.094Zm1.094-1.285h1.285v1.285h-1.286Z",
    transform: "translate(-271.371 -269.426)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2319",
    "data-name": "Ellipse 2319",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(10.008 5.195)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2320",
    "data-name": "Ellipse 2320",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(7.629 5.195)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33366",
    "data-name": "Path 33366",
    d: "M13.453,9.625A.547.547,0,0,0,14,9.078v-5.8a2.19,2.19,0,0,0-2.187-2.187H11.1V.547a.547.547,0,0,0-1.094,0v.547H7.52V.547a.547.547,0,0,0-1.094,0v.547H3.965V.547a.547.547,0,0,0-1.094,0v.547H2.188A2.19,2.19,0,0,0,0,3.281v8.531A2.19,2.19,0,0,0,2.188,14h9.625A2.19,2.19,0,0,0,14,11.813a.547.547,0,0,0-1.094,0,1.1,1.1,0,0,1-1.094,1.094H2.188a1.1,1.1,0,0,1-1.094-1.094V3.281A1.1,1.1,0,0,1,2.188,2.188h.684v.547a.547.547,0,0,0,1.094,0V2.188H6.426v.547a.547.547,0,0,0,1.094,0V2.188h2.488v.547a.547.547,0,0,0,1.094,0V2.188h.711a1.1,1.1,0,0,1,1.094,1.094v5.8A.547.547,0,0,0,13.453,9.625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2321",
    "data-name": "Ellipse 2321",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(2.871 9.953)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2322",
    "data-name": "Ellipse 2322",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(2.871 5.195)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2323",
    "data-name": "Ellipse 2323",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(2.871 7.574)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2324",
    "data-name": "Ellipse 2324",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(5.25 7.574)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2325",
    "data-name": "Ellipse 2325",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(5.25 5.195)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2326",
    "data-name": "Ellipse 2326",
    cx: 0.547,
    cy: 0.547,
    r: 0.547,
    transform: "translate(5.25 9.953)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d20b1578b3ec283a437537c7a1f0654e.svg";
export { ForwardRef as ReactComponent };